module.exports =
    [
        {
            "name": "Agentlytics",
            "description1": "An AI-powered data analysis platform that lets users interact with their CSV, Parquet, and document data using natural language.",
            "description2": "Uses a multi-agent architecture to route tasks between specialized agents for tabular analysis and document-based RAG, with Python sandbox execution for reliable data processing. Built with observability tools to support scalable, production-oriented AI workflows.",
            "techstack": "Multi-Agent | FastAPI | React | LLMs | RAG | Docker | Redis | Chroma",
            "link": "https://agentlytics.duckdns.org",
            "git": "https://github.com/UvYadav04/Agentlytics-Server",
            "position1": "20% 30%",
            "position2": "80% 70%"
        },
        {
            "name": "Architekt AI",
            "description1": "Built a multi-agent AI system that generates system design architectures from natural language using a pipeline of planner, synthesizer, evaluator, and graph generation agents.",
            "description2": "Implemented iterative self-correcting loops and interactive graph visualization (React Flow) with context-aware chat using RAG for querying generated system designs.",
            "techstack": "React | TypeScript | FastAPI | LangGraph | LangChain | Qdrant | Redis | MongoDB | AWS | Nginx",
            "link": "https://architektai.duckdns.org",
            "git": "https://github.com/UvYadav04/Architekt-AI---server",
            "position1": "25% 35%",
            "position2": "75% 65%"
        },
        {
            "name": "Research Simplified",
            "description1": "Developed an AI-powered research paper simplifier that processes and streams section-wise summaries using a smart chunking pipeline.",
            "description2": "Reduced latency (~8s → ~4s) and improved output relevance by integrating an LLM-based classifier to filter non-informational content, using Redis for fast retrieval and Qdrant for persistence.",
            "techstack": "React | TypeScript | FastAPI | Uvicorn | Redis | Qdrant | LangGraph | AWS | Nginx",
            "link": "https://researchsimplified.duckdns.org",
            "git": "https://github.com/UvYadav04/ResearchSimplified-server",
            "position1": "18% 26%",
            "position2": "82% 74%"
        },

        {
            "name": "Z-Bot",
            "description1": "Built a RAG-based conversational AI system with persistent document memory, allowing users to reuse uploaded documents across sessions using metadata-based retrieval.",
            "description2": "Optimized retrieval and latency (~8s → ~4s) using hybrid search (semantic + metadata), smart chunking, and real-time streaming chat.",
            "techstack": "React | TypeScript | FastAPI | Uvicorn | Qdrant | MongoDB | Redis | LangChain",
            "link": "https://z-bot.duckdns.org/",
            "git": "https://github.com/UvYadav04/Z.bot-RAG---server",
            "position1": "22% 30%",
            "position2": "78% 72%"
        },



        {
            "name": "Rapid Hospitals",
            "description1": "Worked as Next.js developer for a client and developed a platform where user can search nearby hospitals and calculate expenses online rather than going hospitals.",
            "description2": "It allows users to filter hospitals by price and location.",
            "techstack": "Next.js | ShadCN | Typescript",
            "link": "https://rapidh.vercel.app",
            "git": "https://github.com/UvYadav04/Rapidh_Frontend",
            "demo": "https://drive.google.com/file/d/10pkliG__HzybgrsPhE-PCVBq3J0S368F/view?usp=sharing",
            "position1": "15% 25%",
            "position2": "75% 70%"
        },

        {
            "name": "Hodo",
            "description1": "A social community platform where users can share their moments, connect with people nearby, and engage in real-time conversations.",
            "description2": "It fosters interactions through multimedia sharing and location-based networking.",
            "techstack": "Next.js | Node.js | MongoDB | Socket.io",
            "link": "https://hodoofficial.onrender.com",
            "git": "https://github.com/UvYadav04/Hodo",
            "demo": "https://drive.google.com/file/d/17AjjkaTr-Xk4rRoNmijMzGAKBegDBJYL/view?usp=sharing",
            "position1": "5% 15%",
            "position2": "60% 50%"
        },
        {
            "name": "Stavya",
            "description1": "The official website for ‘Stavya,’ a cultural fest celebrating Indian traditions.",
            "description2": "It showcases event details, schedules, and participation guidelines, offering an immersive experience for attendees.",
            "techstack": "React | Node.js | BootStrap | Javascript",
            "link": "https://officialstavya.onrender.com/",
            "git": "https://github.com/UvYadav04/Stavya",
            "demo": "https://drive.google.com/file/d/1bPjT0GOnbBj6LoQA_Wb6D14VvZr2LvzP/view?usp=sharing",
            "position1": "50% 40%",
            "position2": "90% 90%"
        },
        {
            "name": "InstantSS",
            "description1": "A browser extension that enables users to capture screenshots instantly and save them as PDFs.",
            "description2": "It offers an efficient way to organize and store screenshots without external tools.",
            "techstack": "HTML | CSS | Javascript | Index DB",
            "link": "https://hodoofficial.onrender.com",
            "git": "https://github.com/UvYadav04/Hodo",
            "demo": "https://drive.google.com/file/d/1SiHYIk5hTJHeZWRqY2icsiZqFm1X5-iX/view?usp=sharing",
            "position1": "20% 35%",
            "position2": "80% 20%"
        },
        {
            "name": "Nutrifit",
            "description1": "A comprehensive diet and fitness platform that provides personalized meal plans, workout routines, and home remedies.",
            "description2": "It helps users maintain a healthy lifestyle with tailored recommendations.",
            "techstack": "React | Node.js | Javascript | Bootstrap",
            "link": "https://nutrifit-2lm8.onrender.com",
            "git": "https://github.com/UvYadav04/Nutrifit",
            "position1": "75% 70%",
            "position2": "15% 25%"
        }
    ]


